import React from 'react';
import {
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Trash2 } from 'lucide-react';
import { CourseStage } from '../../types/CourseStageAccordion.type';
import { treeItemSx } from '../common/TreeBranch';

interface CourseStageCardProps {
  stage: CourseStage;
  onEdit: (stage: CourseStage) => void;
  onDelete: (stage: CourseStage) => void;
}

const CourseStageCard: React.FC<CourseStageCardProps> = ({
  stage,
  onEdit,
  onDelete,
}) => {
  return (
    <ListItem
      disablePadding
      secondaryAction={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            edge="end"
            aria-label="edit"
            onClick={() => onEdit(stage)}
            sx={{ ml: 1 }}
          >
            <Edit size={14} />
          </IconButton>
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => onDelete(stage)}
            sx={{ ml: 1 }}
          >
            <Trash2 size={14} />
          </IconButton>
        </Box>
      }
      sx={[
        {
          mb: 1,
          py: 1,
          px: 2,
          backgroundColor: 'background.paper',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
        treeItemSx,
      ]}
    >
      <ListItemText
        primary={
          <Typography variant="body2" component="div" fontWeight="medium">
            {stage.stageName}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default CourseStageCard;
